import { Chip } from '@mui/material';
import { useTranslation } from '../../../hooks/useTranslation';
import { ResourceVisibility } from '../../../interfaces/ResourceAccess';
import {
  getResourceVisibilityTranslationKey,
  normalizeResourceAccess,
} from '../../../utils/resourceAccess';

interface ResourceVisibilityBadgeProps {
  access?: { visibility?: ResourceVisibility; shared_with_user_ids?: string[] };
}

const visibilityStyles: Record<
  ResourceVisibility,
  { bgcolor: string; color: string }
> = {
  private: { bgcolor: '#F1F5F9', color: '#475569' },
  company: { bgcolor: '#EEF2FF', color: '#1841ff' },
  shared: { bgcolor: '#ECFDF5', color: '#047857' },
};

const ResourceVisibilityBadge: React.FC<ResourceVisibilityBadgeProps> = ({
  access,
}) => {
  const { t } = useTranslation();
  const visibility = normalizeResourceAccess(access).visibility;
  const styles = visibilityStyles[visibility];

  return (
    <Chip
      label={t(getResourceVisibilityTranslationKey(visibility))}
      size="small"
      sx={{
        bgcolor: styles.bgcolor,
        color: styles.color,
        fontWeight: 600,
        fontSize: '0.72rem',
        height: 24,
        '& .MuiChip-label': { px: 1.25 },
      }}
    />
  );
};

export default ResourceVisibilityBadge;
